/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import 'can/view/view';
import 'components/brightcove-video/brightcove-video';

export const FeaturedVideo = BaseControl.extend({
    init: function () {
        this._super();
        this.videoContainer = this.element.find('.s-video-player');
        this.previewContainer = this.element.find('.s-video-preview');
        this.videoContainer.hide();
        this.videoContainer.append(can.stache('<brightcove-video {video-id}="videoId" (ended)="openPreview()"/>')({
            videoId: this.options.videoId,
            openPreview: () => {
                this.previewContainer.show();
                this.videoContainer.hide();
            }
        }));
        this.videoPlayer = this.videoContainer.find('brightcove-video');
    },

    '.s-btn-play click': function () {
        this.previewContainer.hide();
        this.videoContainer.show();
        this.videoPlayer.viewModel().play();
    }
});
